



























import Vue from 'vue'
import mixins from 'vue-typed-mixins'

import TreatmentMixin from '@/views/treatment/TreatmentMixin'

export default mixins(TreatmentMixin).extend({
  computed: {
    letterNumber(): number {
      return this.breadcrumb || parseInt(this.letter.substring(1), 10)
    },
  },
  props: {
    letter: {
      type: String,
      required: true,
    },
    breadcrumb: {
      type: Number,
    },
  },
})
